import React, { useState } from 'react';
import { isLoggedIn, getUser, clearAuth } from './auth';
import AuthScreen from './screens/AuthScreen';
import HomeScreen from './screens/HomeScreen';
import WorkoutScreen from './screens/WorkoutScreen';
import SessionDetailScreen from './screens/SessionDetailScreen';
import ProgressScreen from './screens/ProgressScreen';

export default function App() {
  const [user, setUser] = useState(isLoggedIn() ? getUser() : null);
  const [screen, setScreen] = useState('home');
  const [activeSession, setActiveSession] = useState(null);
  const [selectedSessionId, setSelectedSessionId] = useState(null);

  const handleAuth = (userData) => {
    setUser(userData);
    setScreen('home');
  };

  const handleLogout = () => {
    clearAuth();
    setUser(null);
    setScreen('home');
  };

  const startWorkout = (session) => {
    setActiveSession(session);
    setScreen('workout');
  };

  const endWorkout = () => {
    setActiveSession(null);
    setScreen('home');
  };

  const viewSession = (sessionId) => {
    setSelectedSessionId(sessionId);
    setScreen('detail');
  };

  if (!user) {
    return <AuthScreen onAuth={handleAuth} />;
  }

  return (
    <div>
      {screen === 'home' && (
        <HomeScreen
          onStartWorkout={startWorkout}
          onViewSession={viewSession}
          onViewProgress={() => setScreen('progress')}
          onLogout={handleLogout}
          user={user}
        />
      )}
      {screen === 'workout' && (
        <WorkoutScreen session={activeSession} onEndWorkout={endWorkout} />
      )}
      {screen === 'detail' && (
        <SessionDetailScreen
          sessionId={selectedSessionId}
          onBack={() => setScreen('home')}
        />
      )}
      {screen === 'progress' && (
        <ProgressScreen onBack={() => setScreen('home')} />
      )}
    </div>
  );
}